import React from 'react';

import { MdImage, MdDelete } from 'react-icons/md';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

import { bytesToMegabytes } from '../../../utils/feedback';

import { RootStyled, ImgItemContainer, FileName, FileSize } from './styles';

export default function FileCard({ name, size, files, setFiles }) {
  const eraseFile = () => {
    const index = files.findIndex((file) => file.name === name);
    setFiles(files.filter((_, i) => i !== index));
  };

  return (
    <RootStyled>
      <ImgItemContainer>
        <MdImage size={24} color="gray" />
      </ImgItemContainer>
      <Box sx={{ flexGrow: 1, marginLeft: '12px' }}>
        <FileName>{name}</FileName>
        <FileSize>{`${bytesToMegabytes(size)}mb`}</FileSize>
      </Box>
      <Box>
        <IconButton onClick={eraseFile}>
          <MdDelete color="red" />
        </IconButton>
      </Box>
    </RootStyled>
  );
}
